module.exports = __webpack_public_path__ + "img/banner-bni-pop-up.3fed84ba.webp";